import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="person-group"
export default class extends Controller {
  connect() {
  }

  checkRowAll(event) {
    const row = event.target.closest('tr');
    const checkboxes = row.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = true;
    });
  }

  uncheckRowAll(event) {
    const row = event.target.closest('tr');
    const checkboxes = row.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
  }

  checkCrossAll(event) {
    const table = event.target.closest('table');
    const checkboxes = table.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = true;
    });
  }

  uncheckCrossAll(event) {
    const table = event.target.closest('table');
    const checkboxes = table.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
  }

  checkColumnAll(event) {
    const table = event.target.closest('table');
    const columnIndex = event.target.closest('th, td').cellIndex;
    const rows = table.querySelectorAll('tr');
    
    rows.forEach(row => {
      const cell = row.cells[columnIndex];
      if (cell) {
        const checkbox = cell.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.checked = true;
        }
      }
    });
  }

  uncheckColumnAll(event) {
    const table = event.target.closest('table');
    const columnIndex = event.target.closest('th, td').cellIndex;
    const rows = table.querySelectorAll('tr');
    
    rows.forEach(row => {
      const cell = row.cells[columnIndex];
      if (cell) {
        const checkbox = cell.querySelector('input[type="checkbox"]');
        if (checkbox) {
          checkbox.checked = false;
        }
      }
    });
  }
}
